var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.pageLoading
      ? _c(
          "div",
          { staticClass: "h-screen w-screen grid place-items-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center font-logo font-bold text-4xl text-light-purple animate-pulse"
              },
              [_vm._v("\n      Blüm Report\n    ")]
            )
          ]
        )
      : _vm.report
      ? _c(
          "div",
          { class: { "select-none": _vm.dragMove } },
          [
            _c("ReportHeader", {
              attrs: { mode: _vm.mode, saving: _vm.saving },
              on: {
                "change-mode": function($event) {
                  _vm.mode = $event
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex",
                style: { minHeight: "calc(100vh - 3.75rem)" }
              },
              [
                _c("div", { staticClass: "w-20 flex-shrink-0" }),
                _vm._v(" "),
                _c("Editor", {
                  attrs: {
                    mode: _vm.mode,
                    sectionFocusedId: _vm.sectionFocusedId,
                    dragMove: _vm.dragMove,
                    dragTarget: _vm.dragTarget
                  },
                  on: {
                    "change-saving": function($event) {
                      _vm.saving = $event
                    },
                    "change-focus-id": function($event) {
                      _vm.sectionFocusedId = $event
                    }
                  }
                }),
                _vm._v(" "),
                _vm.mode === "edit"
                  ? _c("ReportHelper", {
                      attrs: {
                        sectionFocusedId: _vm.sectionFocusedId,
                        dragId: _vm.dragId
                      },
                      on: {
                        "change-focus-id": function($event) {
                          _vm.sectionFocusedId = $event
                        },
                        "drag-start": _vm.dragStart
                      }
                    })
                  : _c("div", { staticClass: "w-20 flex-shrink-0" })
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.dragTarget
      ? _c(
          "div",
          {
            ref: "blClientTargetDecoy",
            staticClass: "pointer-events-none fixed",
            style: {
              left: _vm.dragPos.x + "px",
              top: _vm.dragPos.y + "px",
              width: _vm.dragPos.w + "px",
              zIndex: 100
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "w-104 py-2 px-2 flex items-center justify-between gap-2 bg-pure-white border border-slate-400 rounded"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center gap-2 truncate",
                    attrs: { title: _vm.dragTarget.name }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("BlIcon", {
                          staticClass: "h-5 w-5",
                          attrs: { icon: "drag", color: "slate-8" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "truncate",
                      attrs: { text: _vm.dragTarget.name }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex items-center gap-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex",
                      class: {
                        "opacity-0": _vm.dragTarget.type === "cumulative"
                      }
                    },
                    [
                      _c("BlChip", {
                        attrs: {
                          chip:
                            _vm.dragTarget.status === "in_progress"
                              ? "in_acquisition"
                              : _vm.dragTarget.status
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { title: "Add graph" } },
                    [
                      _c("BlIcon", {
                        staticClass: "h-4 w-4",
                        attrs: { icon: "plus", color: "slate-8" }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c068bb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c068bb4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Report.vue
// module id = null
// module chunks = 